import React from 'react';
import { StyleSheet, View } from 'react-native';
import Illustration from 'shared/components/vxl/Illustration/Illustration';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleSmText from 'shared/components/vxl/typography/primary/title/TitleSmText';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import theme from 'shared/styles/theme';

interface FullScreenLoadingProps {
  isCoinLoader?: boolean;
  titleText?: string;
  bodyText?: string;
  analyticsId?: string;
  customAttributes?: Record<string, string>;
}

const FullScreenLoading = ({
  isCoinLoader = false,
  bodyText = '',
  titleText = '',
  analyticsId = '',
  customAttributes,
}: FullScreenLoadingProps) => {
  useViewDidFocusScreenAnalyticsEvent(
    analyticsId
      ? {
          key: analyticsId,
          customAttributes,
        }
      : null,
  );

  return (
    <View style={styles.container}>
      <View style={styles.subContainer}>
        {isCoinLoader ? (
          <>
            <View style={styles.coinWrapper}>
              <Illustration
                illustration="LOADING_COIN_ANIMATED"
                accessibilityLabel="Loading coin animation"
              />
            </View>
            {titleText ? (
              <TitleSmText style={styles.titleTextStyle}>
                {titleText}
              </TitleSmText>
            ) : null}
            {bodyText ? (
              <BodyBaseText style={styles.bodyTextStyle}>
                {bodyText}
              </BodyBaseText>
            ) : null}
          </>
        ) : (
          <LoadingSpinner fill={theme.color.text.secondary} />
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  bodyTextStyle: {
    color: theme.color.text.primary,
    marginTop: theme.spacing.s,
    textAlign: 'center',
  },
  coinWrapper: {
    height: 48,
    width: 48,
  },
  container: {
    alignItems: 'center',
    backgroundColor: theme.color.background.primary,
    flexGrow: 1,
    height: '100%',
    justifyContent: 'center',
    width: '100%',
  },
  subContainer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    width: 320,
  },
  titleTextStyle: {
    color: theme.color.text.primary,
    marginTop: theme.spacing.m,
    textAlign: 'center',
  },
});

export default FullScreenLoading;
